import { Navigate, Route, Routes } from 'react-router-dom';
import InventoryAddProducts from '../../Pages/InventoryAddProduct/InventoryAddProducts.Page';
import { InventoryAddProductFormContextProvider } from '../../Context/InventoryAddProductFormContext';
import { InventoryEditProductFormContextProvider } from '../../Context/InventoryEditProductFormContext';
import InventoryProductDetails from '../../Pages/InventoryProduct/InventoryProductDetails.Page';
import InventoryEditProduct from '../../Pages/InventoryEditProduct/InventoryEditProduct';
import InventoryManagement from '../../Pages/InventoryManagement/InventoryManagement.Page';
import { InventoryManagementContextProvider } from '../../Context/InventoryManagementContext';
import SizeCharts from '../../Pages/SizeCharts/SizeCharts.Page';
import AddSizeChart from '../../Pages/AddSizeChart/AddSizeChart.Page';
import EditSizeChart from '../../Pages/EditSizeChart/EditSizeChart.Page';
import { AddSizeChartContextProvider } from '../../Context/AddSizeChartContext';
import { EditSizeChartContextProvider } from '../../Context/EditSizeChartContext';
import EditVariant from '../../Pages/EditVariant/EditVariant.Page';
import { EditVariantFormContextProvider } from '../../Context/EditVariantFormContext';

function InventoryManagementRoute() {
    return (
        <Routes>
            <Route 
                index 
                element={
                    <InventoryManagementContextProvider>
                        <InventoryManagement />
                    </InventoryManagementContextProvider>
                } 
            />

            <Route path='product'>
                <Route index element={<Navigate to="/inventory-management" replace />} />

                <Route path=':productId' element={<InventoryProductDetails />} />
            </Route>

            <Route 
                path='edit-variant' 
                element={
                    <EditVariantFormContextProvider>
                        <EditVariant />
                    </EditVariantFormContextProvider>
                } 
            />

            <Route path='size-charts'>
                <Route 
                    index 
                    element={
                        <SizeCharts />
                    } 
                />

                <Route 
                    path='add-size-chart' 
                    element={
                        <AddSizeChartContextProvider>
                            <AddSizeChart />
                        </AddSizeChartContextProvider>
                    } 
                />

                <Route path='edit-size-chart'>
                    <Route index element={<Navigate to=".." replace />} />

                    <Route 
                        path=':chartId' 
                        element={
                            <EditSizeChartContextProvider>
                                <EditSizeChart />
                            </EditSizeChartContextProvider>
                        } 
                    />
                </Route>
            </Route>

            <Route 
                path='add-product' 
                element={
                    <InventoryAddProductFormContextProvider>
                        <InventoryAddProducts />
                    </InventoryAddProductFormContextProvider>
                } 
            />

            <Route path='edit-product'>
                <Route index element={<Navigate to="/inventory-management" replace />} />

                <Route 
                    path=':productId' 
                    element={
                        <InventoryEditProductFormContextProvider>
                            <InventoryEditProduct />
                        </InventoryEditProductFormContextProvider>
                    } 
                />
            </Route>
        </Routes>
    );
}

export default InventoryManagementRoute;
